<template>
  <nav class="h-navbar-desktop fixed top-0 left-0 z-10 w-full bg-white shadow">
    <div class="border-primary-500 w-full h-full border-t-4">
      <div class="container flex h-full space-x-5">
        <router-link
          to="/"
          class="flex items-center py-3"
        >
          <img
            src="/img/icons/svg/logo-navbar.svg"
            alt="Carbonii"
            class="h-full"
          >
        </router-link>
        <div class="flex space-x-3">
          <NavbarDesktopLink
            v-for="link in links"
            :key="link.url"
            :title="link.title"
            :url="link.url"
            :icon="link.icon"
          />
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import NavbarDesktopLink from "./NavbarDesktopLink.vue";
export default {
  components: { NavbarDesktopLink },
  computed: {
    links() {
      let links =  [
        { title: "News feed", icon: "newspaper", url: "/news-feed" },
        { title: "Favorites", icon: "star", url: "/favorites" },
        { title: "My goals", icon: "bookmark-check", url: "/goals" },
      ];

      if (this.$laravel.user.is_subscribed) {
        links.push({title: "Billing", icon: "cash", url: "/billing"});
      }

      links.push(
        { title: "Account", icon: "account", url: "/account" }
      );

      return links;
    }
  }
};
</script>
